import { Box, Flex, Heading, Text } from '@chakra-ui/react';
import { ExclamationTriangleIcon } from '@heroicons/react/20/solid';
import { useTranslate } from '@tolgee/react';

export default function ChakraFeatureAlert() {
  const { t } = useTranslate();

  return (
    <Box rounded="md" bg="green.100" p={4} mb={2}>
      <Flex>
        <Box flexShrink={0}>
          <ExclamationTriangleIcon className="h-5 w-5 text-green-500" aria-hidden="true" />
        </Box>
        <Box ml={3}>
          <Heading as="h3" fontSize="sm" fontWeight="semibold">
            {t('happy-hour.premium.local-order.alert.header')}
          </Heading>
          <Text mt={2} fontSize="sm" color="gray.700">
            <pre className="text-wrap">{t('happy-hour.premium.local-order.alert.message')}</pre>
          </Text>
        </Box>
      </Flex>
    </Box>
  );
} 